$(document).ready(function () {

	$('table.table--searchable').each((tableId, table) => {
		let searchableId = $(table).attr('data-searchable-table-id');

		/**
		 * Filter the searchable table
		 * @method
		 */
		$(document).on('keyup', `#${searchableId}`, function() {
			let searchTerm = $(this).val().toLowerCase();

			$(table).find('tbody tr:not(.empty-content)').filter(function() {

				let searchableValues = [];
				$(this).find('td:not([searchable="false"])').each((datacellId, datacell) => {
					if ($(datacell).get(0).hasAttribute('searchable-value')) {
						searchableValues.push($(datacell).attr('searchable-value').trim());
					} else {
						searchableValues.push($(datacell).text().trim());
					}
				});

				$(this).toggle(searchableValues.join(' ').toLowerCase().indexOf(searchTerm) > -1);
			});
		});
	});
});
